// extracted by mini-css-extract-plugin
var _1 = "PostSeriesInTopicList-module__popOver--LQnQA";
var _2 = "PostSeriesInTopicList-module__seriesIcon--dCUMO";
var _3 = "PostSeriesInTopicList-module__seriesIndex--BYpb9";
export { _1 as "popOver", _2 as "seriesIcon", _3 as "seriesIndex" }
